import { Routes } from '@angular/router';
import { AppPath } from '@shared/routes/app-routing.const';
import { NotFoundComponent } from '@content/not-found/not-found.component';
import { HomeComponent } from '@content/home/home.component';
import { AboutUsComponent } from '@content/about-us/about-us.component';
import { ContactUsComponent } from '@content/contact-us/contact-us.component';
import { FeaturesComponent } from '@content/features/features.component';
import { PricingComponent } from '@content/pricing/pricing.component';
import { metaTagsResolver } from '@shared/meta-tags/meta-tags.resolver';
import { PrivacyPolicyComponent } from '@content/policy/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from '@content/policy/terms-and-conditions/terms-and-conditions.component';

const baseUrl = 'https://companyid.io/';

export const routes: Routes = [
    {
        path: AppPath.EMPTY,
        children: [
            {
                path: AppPath.EMPTY,
                component: HomeComponent,
                data: {
                    breadcrumb: $localize`:@@breadcrumb-home:Home`,
                    title: $localize`:@@browser-title-home:companyid.io - Streamline, Simplify, Succeed`,
                    metaTags: {
                        description: $localize`:@@browser-description-home:companyid.io - Streamline business tracking and reporting, enhance operational efficiency, and integrate efficient accounting. Simplify tasks and project management with real-time data access and comprehensive notifications.`,
                        keywords: $localize`:@@browser-keywords-home:business tracking, reporting, operational efficiency, accounting integration, task management, project management, real-time data, notifications, data analytics`,
                        'og:url': baseUrl,
                        'og:title': $localize`:@@browser-og-title-home:companyid.io - Streamline, Simplify, Succeed`,
                        'og:description': $localize`:@@browser-og-description-home:companyid.io - Streamline business tracking and reporting, enhance operational efficiency, and integrate efficient accounting. Simplify tasks and project management with real-time data access and comprehensive notifications.`,
                        // 'og:image': 'https://jsdaddy.io/og-image.jpg'
                    },
                },
                resolve: {
                    metaTags: metaTagsResolver,
                },
            },
            {
                path: AppPath.ABOUT_US,
                component: AboutUsComponent,
                data: {
                    breadcrumb: $localize`:@@breadcrumb-about-us:About us`,
                    title: $localize`:@@browser-title-about-us:companyid.io - About Us`,
                    metaTags: {
                        description: $localize`:@@browser-description-about-us:Learn more about companyid.io, our mission, values, and the team dedicated to helping you streamline your business operations.`,
                        keywords: $localize`:@@browser-keywords-about-us:about us, companyid.io, mission, values, team`,
                        'og:url': `${baseUrl}${AppPath.ABOUT_US}`,
                        'og:title': $localize`:@@browser-og-title-about-us:companyid.io - About Us`,
                        'og:description': $localize`:@@browser-og-description-about-us:Learn more about companyid.io, our mission, values, and the team dedicated to helping you streamline your business operations.`,
                        // 'og:image': 'https://companyid.io/about-og-image.jpg',
                    },
                },
                resolve: {
                    metaTags: metaTagsResolver,
                },
            },
            // {
            //     path: AppPath.BLOG,
            //     component: BlogComponent,
            //     data: {
            // breadcrumb: 'Pricing',

            //         title: 'Blog | CompanyId',
            //     },
            //     resolve: {
            //          metaTags: metaTagsResolver,
            //     },
            // },
            {
                path: AppPath.CONTACT_US,
                component: ContactUsComponent,
                data: {
                    breadcrumb: $localize`:@@breadcrumb-contact-us:Contact us`,
                    title: $localize`:@@browser-title-contact-us:companyid.io - Contact Us`,
                    metaTags: {
                        description: $localize`:@@browser-description-contact-us:Get in touch with us at companyid.io. We are here to help you streamline your business operations and provide the best solutions for your needs.`,
                        keywords: $localize`:@@browser-keywords-contact-us:contact, support, customer service, business solutions, companyid.io contact`,
                        'og:url': `${baseUrl}${AppPath.CONTACT_US}`,
                        'og:title': $localize`:@@browser-og-title-contact-us:companyid.io - Contact Us`,
                        'og:description': $localize`:@@browser-og-description-contact-us:Get in touch with us at companyid.io. We are here to help you streamline your business operations and provide the best solutions for your needs.`,
                        // 'og:image': 'https://jsdaddy.io/contact-og-image.jpg'
                    },
                },
                resolve: {
                    metaTags: metaTagsResolver,
                },
            },
            {
                path: AppPath.FEATURES,
                component: FeaturesComponent,
                data: {
                    breadcrumb: $localize`:@@breadcrumb-features:Features`,
                    title: $localize`:@@browser-title-features:companyid.io - Streamline, Simplify, Succeed`,
                    metaTags: {
                        description: $localize`:@@browser-description-features:companyid.io - Streamline business tracking and reporting, enhance operational efficiency, and integrate efficient accounting. Simplify tasks and project management with real-time data access and comprehensive notifications.`,
                        keywords: $localize`:@@browser-keywords-features:business tracking, reporting, operational efficiency, accounting integration, task management, project management, real-time data, notifications, data analytics`,
                        'og:url': `${baseUrl}${AppPath.FEATURES}`,
                        'og:title': $localize`:@@browser-og-title-features:companyid.io - Streamline, Simplify, Succeed`,
                        'og:description': $localize`:@@browser-og-description-features:companyid.io - Streamline business tracking and reporting, enhance operational efficiency, and integrate efficient accounting. Simplify tasks and project management with real-time data access and comprehensive notifications.`,
                        // 'og:image': 'https://jsdaddy.io/og-image.jpg',
                    },
                },
                resolve: {
                    metaTags: metaTagsResolver,
                },
            },
            {
                path: AppPath.PRICING,
                component: PricingComponent,
                data: {
                    breadcrumb: $localize`:@@breadcrumb-pricing:Pricing`,
                    title: $localize`:@@browser-title-pricing:companyid.io - Pricing Plans`,
                    metaTags: {
                        description: $localize`:@@browser-description-pricing:Discover our flexible pricing plans at companyid.io. Choose the best plan that fits your business needs.`,
                        keywords: $localize`:@@browser-keywords-pricing:pricing, plans, business solutions, flexible pricing, companyid.io pricing`,
                        'og:url': `${baseUrl}${AppPath.PRICING}`,
                        'og:title': $localize`:@@browser-og-title-pricing:companyid.io - Pricing Plans`,
                        'og:description': $localize`:@@browser-og-description-pricing:Discover our flexible pricing plans at companyid.io. Choose the best plan that fits your business needs.`,
                        // 'og:image': 'https://jsdaddy.io/pricing-og-image.jpg'
                    },
                },
                resolve: {
                    metaTags: metaTagsResolver,
                },
            },
            // {
            //     path: AppPath.COOKIE_POLICY,
            //     component: CookiePolicyComponent,
            //     data: {
            //         breadcrumb: $localize`:@@breadcrumb-cookie-policy:Cookie policy`,
            //         title: $localize`:@@browser-title-cookie-policy:companyid.io - Cookie Policy`,
            //         metaTags: {
            //             description: $localize`:@@browser-description-cookie-policy:Read about our cookie policy at companyid.io. Learn how we use cookies to enhance your browsing experience.`,
            //             keywords: $localize`:@@browser-keywords-cookie-policy:cookie policy, JSDaddy.io, cookies, privacy`,
            //             'og:url': baseUrl + AppPath.COOKIE_POLICY,
            //             'og:title': $localize`:@@browser-og-title-cookie:companyid.io - Cookie Policy`,
            //             'og:description': $localize`:@@browser-og-description-cookie:Read about our cookie policy at companyid.io. Learn how we use cookies to enhance your browsing experience.`,
            //             'og:image': 'https://jsdaddy.io/cookie-policy-og-image.jpg',
            //         }
            //     },
            //     resolve: {
            //         metaTags: metaTagsResolver,
            //     },
            // },
            {
                path: AppPath.PRIVACY_POLICY,
                component: PrivacyPolicyComponent,
                data: {
                    breadcrumb: $localize`:@@breadcrumb-privacy-policy:Privacy Policy`,
                    title: $localize`:@@browser-title-privacy-policy:companyid.io - Privacy Policy`,
                    metaTags: {
                        description: $localize`:@@browser-description-privacy-policy:Read our privacy policy at companyid.io. Learn how we handle and protect your personal information.`,
                        keywords: $localize`:@@browser-keywords-privacy-policy:privacy policy, companyid.io, personal information, data protection`,
                        'og:url': `${baseUrl}${AppPath.PRIVACY_POLICY}`,
                        'og:title': $localize`:@@browser-og-title-privacy-policy:companyid.io - Privacy Policy`,
                        'og:description': $localize`:@@browser-og-description-privacy-policy:Read our privacy policy at companyid.io. Learn how we handle and protect your personal information.`,
                        // 'og:image': 'https://jsdaddy.io/privacy-policy-og-image.jpg'
                    },
                },
                resolve: {
                    metaTags: metaTagsResolver,
                },
            },
            {
                path: AppPath.TERMS_AND_CONDITIONS,
                component: TermsAndConditionsComponent,
                data: {
                    breadcrumb: $localize`:@@breadcrumb-terms-and-conditions:Terms and conditions`,
                    title: $localize`:@@browser-title-terms-and-conditions:companyid.io - Terms and Conditions`,
                    metaTags: {
                        description: $localize`:@@browser-description-terms-and-conditions:Read the terms and conditions of using companyid.io. Understand the rules and regulations for using our services.`,
                        keywords: $localize`:@@browser-keywords-terms-and-conditions:terms and conditions, companyid.io, rules, regulations`,
                        'og:url': `${baseUrl}${AppPath.TERMS_AND_CONDITIONS}`,
                        'og:title': $localize`:@@browser-og-title-terms-and-conditions:companyid.io - Terms and Conditions`,
                        'og:description': $localize`:@@browser-og-description-terms-and-conditions:Read the terms and conditions of using companyid.io. Understand the rules and regulations for using our services.`,
                        // 'og:image': 'https://jsdaddy.io/terms-conditions-og-image.jpg',
                    },
                },
                resolve: {
                    metaTags: metaTagsResolver,
                },
            },
            {
                path: AppPath.ALL,
                component: NotFoundComponent,
                data: {
                    title: $localize`:@@browser-title-not-found:Not Found | CompanyId`,
                    keywords: {
                        name: 'Description',
                        content: 'CompanyID is ....',
                    },
                },
                resolve: {
                    metaTags: metaTagsResolver,
                },
            },
        ],
    },
];
